import { Star } from "lucide-react";

type Props = { className?: string };

export function FoundingMemberBadge({ className = "" }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-2.5 border border-foreground/30 bg-foreground/[0.04] px-5 py-2 eyebrow text-[11px] tracking-[0.18em] ${className}`}
      title="Gründungsmitglied von OM Selected"
    >
      <Star className="h-3 w-3 fill-foreground" aria-hidden />
      Founding Member
    </span>
  );
}